(() => {
  if (window.__knotNewsletterTracking) return;
  window.__knotNewsletterTracking = true;
  const key = 'knot_newsletter_pending_v1';
  const selector = 'form.newsletter-form, form.section-newsletter-form';
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const observed = new WeakSet();
  const debug = new URLSearchParams(window.location.search).get('kn_newsletter_debug') === '1';
  const report = (stage, details = {}) => { if (debug) console.info('[Knot newsletter] ' + stage + ' ' + JSON.stringify(details)); };
  let sending = false;
  const permitted = () => {
    const p = window.Shopify?.customerPrivacy;
    return p?.marketingAllowed?.() === true && p?.analyticsProcessingAllowed?.() === true && p?.saleOfDataAllowed?.() === true;
  };
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const read = () => {
    try {
      const item = JSON.parse(sessionStorage.getItem(key));
      if (!item || !uuid.test(item.id) || !Number.isFinite(item.at) ||
          Date.now() < item.at || Date.now() - item.at > 600000 ||
          typeof item.inputId !== 'string' || !['footer', 'section', 'flyout'].includes(item.surface)) {
        clear();
        return null;
      }
      return item;
    } catch (_) { clear(); return null; }
  };
  const surface = form => form.id.startsWith('KnotFriends-') ? 'flyout' : form.classList.contains('newsletter-form') ? 'footer' : 'section';
  const eligible = form => form?.matches?.(selector) && form.querySelector('input[name="form_type"]')?.value === 'customer' &&
    form.querySelector('input[name="contact[tags]"]')?.value === 'newsletter';
  const deliver = () => {
    if (sending || !permitted() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    const item = read();
    if (!item) return;
    const input = document.getElementById(item.inputId);
    const form = input?.closest('form');
    if (!eligible(form) || surface(form) !== item.surface || !form.querySelector('[id^="Newsletter-success--"]') ||
        form.querySelector('[id^="Newsletter-error--"]')) return;
    sending = true;
    clear();
    try {
      const result = window.Shopify.analytics.publish('knotnot:newsletter_signup', {
        submission_id: item.id, form_surface: item.surface, confirmed: true
      });
      report('published', { surface: item.surface, submission_id: item.id });
      if (result?.catch) result.catch(() => report('publish-rejected'));
    } catch (_) { report('publish-failed'); }
    sending = false;
  };
  const remember = event => {
    const form = event.target;
    if (!eligible(form)) return;
    if (!permitted()) { clear(); report('consent-blocked'); return; }
    if (!form.checkValidity() ||
        form.querySelector('[id^="Newsletter-success--"]')) return;
    const input = form.querySelector('input[name="contact[email]"]');
    if (!input?.id || typeof window.crypto?.randomUUID !== 'function') return;
    try {
      const pending = read();
      if (pending?.inputId === input.id && pending.surface === surface(form)) return;
      sessionStorage.setItem(key, JSON.stringify({ id: window.crypto.randomUUID(), at: Date.now(), inputId: input.id, surface: surface(form) }));
      report('submission-recorded', { surface: surface(form), trigger: event.type });
    } catch (_) { clear(); report('storage-unavailable'); }
  };
  document.addEventListener('submit', remember, true);
  document.addEventListener('formdata', remember, true);
  const bind = () => {
    document.querySelectorAll(selector).forEach(form => {
      if (!eligible(form) || observed.has(form)) return;
      observed.add(form);
      new MutationObserver(deliver).observe(form, { childList: true, subtree: true });
    });
    report('ready', { permitted: permitted(), forms: document.querySelectorAll(selector).length });
    deliver();
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (!permitted()) clear();
    else deliver();
  });
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', deliver);
  window.addEventListener('pageshow', deliver);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      report('privacy-ready', { loaded: !error, permitted: permitted() });
      if (!error) deliver();
    });
  }
  let attempts = 0;
  const readyTimer = setInterval(() => {
    deliver();
    if (++attempts >= 30) clearInterval(readyTimer);
  }, 500);
})();

(() => {
  if (window.__knotAccountNewsletter) return;
  window.__knotAccountNewsletter = true;
  const key = 'knot_account_newsletter_pending_v1';
  const sentKey = 'knot_account_newsletter_sent_v1';
  const surfaces = ['account_login', 'membership_popup'];
  const ttl = 15 * 60 * 1000;
  let busy = false;
  let attempts = 0;
  const debug = new URLSearchParams(window.location.search).get('kn_newsletter_debug') === '1';
  const report = (stage, data = {}) => {
    if (debug) console.info('[Knot account newsletter] ' + stage + ' ' + JSON.stringify(data));
  };
  const allowed = () => {
    const p = window.Shopify?.customerPrivacy;
    return p?.marketingAllowed?.() === true && p?.analyticsProcessingAllowed?.() === true && p?.saleOfDataAllowed?.() === true;
  };
  const clear = () => { try { localStorage.removeItem(key); } catch (_) {} };
  const pending = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key));
      if (!data || !surfaces.includes(data.surface) || !Number.isFinite(data.at) ||
          data.at > Date.now() || Date.now() - data.at > ttl) {
        clear();
        return null;
      }
      return data;
    } catch (_) { clear(); return null; }
  };
  const remember = event => {
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    const path = event.composedPath?.() || [event.target];
    const membershipLink = path.find(node => node?.matches?.('.kn-membership a.kn-join, .kn-membership a.kn-social'));
    const account = path.some(node => node?.tagName?.toLowerCase() === 'shopify-login-form');
    if (!membershipLink && !account) return;
    if (!allowed()) { clear(); return; }
    const surface = membershipLink ? 'membership_popup' : 'account_login';
    const previous = pending();
    if (previous?.surface === surface && Date.now() - previous.at < 30000) return;
    try {
      localStorage.setItem(key, JSON.stringify({surface, at: Date.now()}));
      report('intent-recorded', {surface});
    } catch (_) { clear(); }
  };
  const deliver = async () => {
    if (busy || !allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    const item = pending();
    if (!item) return;
    busy = true;
    try {
      const root = window.Shopify.routes?.root || '/';
      const url = new URL(root, window.location.origin);
      url.searchParams.set('section_id', 'knot-newsletter-consent');
      url.searchParams.set('_knnl', String(Date.now()));
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = JSON.parse(doc.getElementById('KnotNewsletterAccountState')?.textContent || 'null');
      if (!state || state.authenticated !== true || state.subscribed !== true ||
          !Number.isFinite(state.confirmed_at) || state.confirmed_at <= 0 ||
          typeof state.confirmation_id !== 'string' || !/^[a-f0-9]{64}$/.test(state.confirmation_id)) return;
      const confirmedAt = state.confirmed_at * 1000;
      if (confirmedAt < Math.floor(item.at / 1000) * 1000 || confirmedAt > Date.now() + 1000 ||
          Date.now() - confirmedAt > ttl) return;
      const current = pending();
      if (!allowed() || !current || current.at !== item.at || current.surface !== item.surface) return;
      let sent;
      try {
        sent = JSON.parse(localStorage.getItem(sentKey) || '[]');
        if (!Array.isArray(sent)) return;
        if (sent.includes(state.confirmation_id)) { clear(); return; }
        localStorage.setItem(sentKey, JSON.stringify([...sent, state.confirmation_id].slice(-30)));
      } catch (_) { return; }
      clear();
      const result = window.Shopify.analytics.publish('knotnot:newsletter_signup', {
        confirmed:true, confirmation_id:state.confirmation_id, form_surface:item.surface
      });
      report('published', {surface:item.surface, confirmation_id:state.confirmation_id});
      if (result?.catch) result.catch(() => report('publish-rejected'));
    } catch (_) { report('verification-unavailable'); }
    finally { busy = false; }
  };
  document.addEventListener('click', remember, true);
  document.addEventListener('keydown', remember, true);
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) clear(); else deliver(); });
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', deliver);
  window.addEventListener('pageshow', deliver);
  window.addEventListener('storage', event => { if (event.key === key) deliver(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deliver, {once:true});
  else deliver();
  const timer = setInterval(() => {
    deliver();
    if (++attempts >= 24) clearInterval(timer);
  }, 5000);
})();
